import { useEffect, useRef } from 'react';
import mermaid from 'mermaid';
import { FlowDefinition, ExportFormat } from '../types';
import { ExportService } from '../services/exportService';

interface FlowViewerProps {
  flow: FlowDefinition;
}

export const FlowViewer: React.FC<FlowViewerProps> = ({ flow }) => {
  const mermaidRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'neutral',
      flowchart: {
        curve: 'linear',
        padding: 15,
        useMaxWidth: false
      }
    });
  }, []);

  useEffect(() => {
    if (mermaidRef.current && flow.graph) {
      mermaidRef.current.innerHTML = flow.graph;
      mermaidRef.current.removeAttribute('data-processed');
      
      mermaid.run({
        nodes: [mermaidRef.current]
      }).catch(err => {
        console.error('Mermaid render error:', err);
        if (mermaidRef.current) {
          mermaidRef.current.innerHTML = 'Error rendering diagram';
        }
      });
    }
  }, [flow]);

  const handleExport = async (format: ExportFormat) => {
    await ExportService.exportMermaid(flow.graph, format, flow.id);
  };

  return (
    <div className="main-content">
      <div className="top-bar">
        <h2>{flow.title}</h2>
        <div className="flow-meta">{flow.meta}</div>
        <div className="export-buttons">
          <button onClick={() => handleExport('mermaid')} title="Export Mermaid Code">
            <i className="fa-solid fa-code"></i>
          </button>
          <button onClick={() => handleExport('svg')} title="Export SVG">
            <i className="fa-solid fa-file-image"></i>
          </button>
          <button onClick={() => handleExport('png')} title="Export PNG">
            <i className="fa-solid fa-image"></i>
          </button>
          <button onClick={() => handleExport('drawio')} title="Export Draw.io">
            <i className="fa-solid fa-diagram-project"></i>
          </button>
        </div>
      </div>

      <div className="content-area">
        <div className="diagram-card">
          <div className="legend-bar">
            <div className="legend-item">
              <div className="dot" style={{ background: '#e1f5fe', border: '1px solid #0277bd' }}></div>
              Action
            </div>
            <div className="legend-item">
              <div className="dot" style={{ background: '#fff9c4', border: '1px solid #fbc02d' }}></div>
              Decision
            </div>
            <div className="legend-item">
              <div className="dot" style={{ background: '#ffebee', border: '1px solid #c62828' }}></div>
              Exit/Transfer
            </div>
            <div className="legend-item">
              <div className="dot" style={{ background: '#e8f5e9', border: '1px solid #2e7d32' }}></div>
              Data
            </div>
            <div className="legend-item">
              <div className="dot" style={{ background: '#f3e5f5', border: '1px solid #7b1fa2' }}></div>
              Sub-Flow
            </div>
          </div>
          <div ref={mermaidRef} className="mermaid"></div>
        </div>
      </div>
    </div>
  );
};
